"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "apecchio": {
    "fd24b7d7": [{
      "hkey": "b93dd0cc",
      "slug": "apecchio",
      "name": "Apecchio",
      "primary": true,
      "skipSearch": false
    }],
    "osteria-nuova": [{
      "hkey": "b93dd0cc",
      "slug": "apecchio",
      "name": "Apecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08f9c833": [{
      "hkey": "f3d7d8e8",
      "slug": "pietragialla",
      "name": "Pietragialla",
      "primary": true,
      "skipSearch": false
    }],
    "pietra-gialla": [{
      "hkey": "f3d7d8e8",
      "slug": "pietragialla",
      "name": "Pietragialla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;